export default "__VITE_ASSET__xcskNqnt__"